import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { advanceParamCheck, isString, logErrorAndRunFail, isNumber } from '../../utils';

export interface ReportEventOption {
  eventId: string;
  eventData?: Object;
  invalidParamObj?: any;
}

const nonemptyParam = { nonempty: true }; // 非空参数
const optionalParam = { optional: true }; // 可选参数

// 自定义埋点上报
export function reportEvent(option: ReportEventOption) {
  if (
    advanceParamCheck(
      APINames.Native.REPORT_EVENT, 
      option, 
      { eventId: '', eventData: {} }, 
      { eventId: nonemptyParam, eventData: optionalParam }
    )
  ) {
    if (!option.eventData) {
      option.eventData = {};
    }
    const eventData = option.eventData as {[key: string]: any};
    for (const key of Object.keys(eventData)) {
      const value = eventData[key];
      if (!isString(value) && !isNumber(value)) {
        return logErrorAndRunFail(
          APINames.Native.REPORT_EVENT,
          option,
          `parameter error:  invalid value ${value}`
        );
      }
      if (isNumber(value)) {
        eventData[key] = Number(value.toFixed(6));
      }
    }
    return MacleJSBridge.notifyNative(APINames.Native.REPORT_EVENT, option);
  }
  return option.invalidParamObj;
}